import { Fee } from './fee.model';

export class FeeValue {
    value: Fee
}
